<template>
    <div class="button-group button-group-multiselect">
        <div class="button-row" v-for="row in buttons">
            <div class="button-group-item" v-for="btn in row">
                <button v-bind:id=btn.text v-on:click="onBtnClick(btn)" v-bind:class="{ active: isSelected(btn) }" v-if="btn">{{ btn.text }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import response from '@/stores/response.js'

    export default {
        name: 'MultiselectButtonGroup',
        created: function () {
            var self = this;
            self.$root.$once("next-panel", function () {
                self.saveData();
            });
        },
        data: function() {
            return {
                isNoOption: false,
                selectedBtns: [],
                response: response,
                selectedValues: []
            }
        },
        computed: {
            value: function() {
                return this.selectedBtns.map(function(val, key) {
                    return val.text
                });
            }
        },
        props: ['buttons'],
        methods: {
            isSelected: function(btn) {
                if(btn.noOption) return this.isNoOption;
                if(this.isNoOption) return false;
                return this.selectedBtns.includes(btn);
            },
            onBtnClick: function(btn) {
                if(btn.noOption) {
                    this.selectedBtns = this.selectedValues = [];
                    this.isNoOption = true;
                    this.selectedBtns.push(btn);
                    this.selectedValues.push(btn.text);
                    return;
                }
                if (this.isNoOption) this.selectedBtns = this.selectedValues = [];
                this.isNoOption = false;
                var idx = this.selectedBtns.indexOf(btn);
                console.log(idx);
                if(idx == -1) {
                    this.selectedBtns.push(btn);
                } else {
                    this.selectedBtns.splice(idx, 1);
                }
                var idy = this.selectedValues.indexOf(btn.text);
                if(idy == -1) {
                    this.selectedValues.push(btn.text);
                }else{
                    this.selectedValues.splice(idy, 1);
                }
            },
            saveData: function() {
                this.response[(this.$parent.$parent.panelState.curPanel - 1)].answer = this.selectedValues;
            }
        }
    }
</script>

<style scoped lang="stylus">
.button-group
    width: 100%
    height: 425px
button
    cursor: pointer
</style>